import { DataGrid, GridColDef } from '@fashionnovateam/nova-ui-toolkit';
import classNames from 'classnames';
import { formatPrice } from '../../../PurchaseOrderDetail/Utils/formatPrice';

type CostChangeProps = {
  jrCost?: number;
  plusCost?: number;
  jrCostCurrently?: number;
  plusCostCurrently?: number;
};

const columns: GridColDef[] = [
  {
    field: 'header',
    headerName: '',
    render: 'custom',
    flex: 1,
    sortable: false,
    minWidth: 88,
    disableColumnMenu: true,
  },
  {
    field: 'jr_cost',
    headerName: 'JR Cost',
    render: 'custom',
    flex: 1,
    sortable: false,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    field: 'plus_cost',
    headerName: 'Plus Cost',
    render: 'custom',
    flex: 1,
    sortable: false,
    minWidth: 150,
    disableColumnMenu: true,
  },
];

function NoData() {
  return <span className="text-sm text-base-disabled">-</span>;
}

export function CostChange(props: CostChangeProps) {
  const { jrCost, plusCost, jrCostCurrently, plusCostCurrently } = props;
  const transformedRows = [
    {
      id: 1,
      header: <span className="text-sm text-base-disabled">Requested</span>,
      jr_cost:
        jrCost !== undefined ? (
          <span className="text-sm font-semibold text-warning-700">
            {formatPrice(jrCost, false, false)}
          </span>
        ) : (
          <NoData />
        ),
      plus_cost:
        plusCost !== undefined ? (
          <span className="text-sm font-semibold text-warning-700">
            {formatPrice(plusCost, false, false)}
          </span>
        ) : (
          <NoData />
        ),
    },
    {
      id: 2,
      header: <span className="text-sm text-base-disabled">Currently</span>,
      jr_cost:
        jrCostCurrently !== undefined ? (
          <span
            className={classNames('text-sm', {
              'line-through text-base-disabled decoration-base-disabled':
                jrCost !== undefined,
            })}
          >
            {formatPrice(jrCostCurrently, false, false)}
          </span>
        ) : (
          <NoData />
        ),
      plus_cost:
        plusCostCurrently !== undefined ? (
          <span
            className={classNames('text-sm', {
              'line-through text-base-disabled decoration-base-disabled':
                plusCost !== undefined,
            })}
          >
            {formatPrice(plusCostCurrently, false, false)}
          </span>
        ) : (
          <NoData />
        ),
    },
  ];
  return (
    <div className="flex flex-col gap-3">
      <span className="text-xsm font-medium text-base-primary">
        Cost Change
      </span>
      <DataGrid
        hideFilterButton
        hideGroupButton
        hideFooterPagination
        hideFooter
        hideSortButton
        rowHeight={32}
        rows={transformedRows}
        columns={columns}
      />
    </div>
  );
}
